// src/services/apiService.js

import baseURL from '../Components/url'; // Asegúrate de que la ruta a tu baseURL sea correcta

const apiService = {
    /**
     * Obtiene los detalles completos de un producto específico.
     * @param {string | number} id - El ID del producto a buscar.
     * @returns {Promise<object>} Los datos del producto.
     */
    fetchProductDetail: async (id) => {
        try {
            const response = await fetch(`${baseURL}/productoDetalleGet.php?idProducto=${id}`);
            if (!response.ok) {
                throw new Error(`Error en la petición: ${response.statusText}`);
            }
            return response.json();
        } catch (error) {
            console.error("Error al obtener el detalle del producto:", error);
            return { error: "No se pudo cargar el producto." };
        }
    },

    /**
     * Obtiene la información de contacto más reciente.
     * @returns {Promise<object>} El objeto de contacto.
     */
    fetchContact: async () => {
        try {
            const response = await fetch(`${baseURL}/contactoGet.php`);
            if (!response.ok) {
                throw new Error(`Error en la petición: ${response.statusText}`);
            }
            const data = await response.json();
            // Devuelve el último contacto registrado o un objeto vacío
            return data.contacto?.reverse()?.[0] || {};
        } catch (error) {
            console.error("Error al obtener la información de contacto:", error);
            return { error: "No se pudo cargar la información de contacto." };
        }
    },

    /**
     * Envía un nuevo pedido a la base de datos.
     * @param {FormData} formData - Los datos del pedido en un objeto FormData.
     * @returns {Promise<object>} La respuesta del servidor.
     */
    createOrder: async (formData) => {
        try {
            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });
            if (!response.ok) {
                throw new Error(`Error en la petición: ${response.statusText}`);
            }
            return response.json();
        } catch (error) {
            console.error("Error al crear el pedido:", error);
            return { error: "No se pudo procesar el pedido." };
        }
    }
};

export default apiService;